import { useSyncStore } from "@/state/sync";

export function SyncStatus() {
  const state = useSyncStore((value) => value.state);
  const pending = useSyncStore((value) => value.pending);
  const label = state === "synced"
    ? "Guardado"
    : state === "syncing"
      ? "Guardando…"
      : state === "offline"
        ? `Sin conexión${pending ? ` · ${pending}` : ""}`
        : state === "error"
          ? `Por guardar${pending ? ` · ${pending}` : ""}`
          : `Por guardar · ${pending}`;
  return (
    <span className="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-widest text-brand-muted" role="status">
      <span aria-hidden>{state === "synced" ? "●" : state === "syncing" ? "↻" : "○"}</span>
      {label}
    </span>
  );
}
